var _path, _circle, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4233 11.3636V23H16.3153V13.4148H16.2472L13.5256 15.1534V13.2216L16.4176 11.3636H18.4233Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 11.1668C12.1665 11.6252 12.5415 12.0002 12.9998 12.0002H22.9998C23.4582 12.0002 23.8332 11.6252 23.8332 11.1668C23.8332 10.7085 23.4582 10.3335 22.9998 10.3335H12.9998C12.5415 10.3335 12.1665 10.7085 12.1665 11.1668ZM14.1748 18.6668H15.4998V22.8335C15.4998 23.2918 15.8748 23.6668 16.3332 23.6668H19.6665C20.1248 23.6668 20.4998 23.2918 20.4998 22.8335V18.6668H21.8248C22.5665 18.6668 22.9415 17.7668 22.4165 17.2418L18.5915 13.4168C18.2665 13.0918 17.7415 13.0918 17.4165 13.4168L13.5915 17.2418C13.0665 17.7668 13.4332 18.6668 14.1748 18.6668Z",
    fill: "#212746"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -86.5,
    y: -22.5,
    width: 143,
    height: 79,
    rx: 4.5,
    stroke: "#7B61FF",
    strokeDasharray: "10 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.2933989a26807d31e02245290662281f.svg";
export { ForwardRef as ReactComponent };